import axios from "axios";

const B_URL = process.env.REACT_APP_LOGINURL


const headers = {
  'Content-Type': 'application/json',
  'token': localStorage.getItem("session-id")
}


const getAllDiscountCoupons = (sessionID, page, limit,text,status,business,businessIDs) => {
  var payload = {
    "functionName": "GetDiscountCoupons",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "coupon_code": text,
      "status": status,
      "business_id": business,
      "businessIDs": businessIDs,
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DiscountCouponsModule/GetDiscountCoupons", payload, { headers });
};

const getAllOrders = (sessionID, page, limit,text,status,business,businessIDs) => {
  var payload = {
    "functionName": "GetAdminOrdersList",
    "postData": {
      "search_text": text,
      "status": status,
      "business_id": business,
      "businessIDs": businessIDs,
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "OrderModule/GetAdminOrdersList", payload, { headers });
};


const GetOrderDetails = (sessionID, order_id) => {
  var payload = {
    "functionName": "GetAdminOrderDetails",
    "postData": {
      "order_id": order_id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "OrderModule/GetAdminOrderDetails", payload, { headers });
};


const getAllBusinesses = (sessionID,page, limit, business) => {
  var payload = {
    "functionName": "GetBusinesses",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "business_ids": business ? business : []
    }
    
  }

  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }

  return axios.post(B_URL + "BusinessModule/GetBusinesses", payload, { headers });
};

const AddDiscountCoupon = (sessionID,data) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "AddDiscountCoupon",
    "postData": {
      "coupon_code": data.coupon_code,
      "total_coupons": data.total_coupons,
      "type": data.type,
      "amount": data.amount,
      "start_date": data.start_date,
      "end_date": data.end_date,
      "status": data.status,
      "business_ids": data.business_ids
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DiscountCouponsModule/AddDiscountCoupon", payload, { headers });
};

const deleteDiscountCoupon = (sessionID,id) => {
  var payload = {
    "functionName": "DeleteDiscountCoupon",
    "postData": {
      "coupon_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DiscountCouponsModule/DeleteDiscountCoupon", payload, { headers });
};


const EditDiscountCoupon = (sessionID,data,id) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "UpdateDiscountCoupon",
    "postData": {
      "coupon_id": id,
      "coupon_code": data.coupon_code,
      "total_coupons": data.total_coupons,
      "type": data.type,
      "amount": data.amount,
      "start_date": data.start_date,
      "end_date": data.end_date,
      "status": data.status,
      "business_id": data.business_id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DiscountCouponsModule/UpdateDiscountCoupon", payload, { headers });
};

const GetSingleDiscountCoupon = (sessionID,id) => {
  var payload = {
    "functionName": "GetSingleDiscountCoupon",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DiscountCouponsModule/GetSingleDiscountCoupon", payload, { headers });
};

const deleteBulkDiscountSection = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkDiscountCoupon",
    "postData": {
      "coupon_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DiscountCouponsModule/DeleteBulkDiscountCoupon", payload, { headers });
};

const updateBulkStatus = (sessionID,selectedRows,type) => {
  var payload = {
    "functionName": "BulkStatusUpdate",
    "postData": {
      "coupon_ids": selectedRows,
      "type": type
    },
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DiscountCouponsModule/BulkStatusUpdate", payload, { headers });
};

const AdminProcessOrder = (sessionID,id,status) => {
  var payload = {
    "functionName": "AdminProcessOrder",
    "postData": {
      "order_id": id,
      "process_with_lalamove": status
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "OrderModule/AdminProcessOrder", payload, { headers });
};

const CancelLalamoveOrder = (sessionID,id) => {
  var payload = {
    "functionName": "CancelLalamove",
    "postData": {
      "order_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "OrderModule/CancelLalamove", payload, { headers });
};

const AdditionalTip = (sessionID,id,amount) => {
  var payload = {
    "functionName": "AddAdminExtraPriority",
    "postData": {
      "order_id": id,
      "amount": amount
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "OrderModule/AddAdminExtraPriority", payload, { headers });
};

const LalamoveLinkID = (sessionID,id,lalamove_id) => {
  var payload = {
    "functionName": "LinkLalamove",
    "postData": {
      "order_id": id,
      "lalamove_order_id": lalamove_id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "OrderModule/LinkLalamove", payload, { headers });
};

const getSettlementReport = (sessionID, page, limit,business,date,businessIDs) => {
  var payload = {
    "functionName": "SettlementReport",
    "postData": {
      "business_id": business,
      "date_range": date,
      "businessIDs": businessIDs,
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "ReportsModule/SettlementReport", payload, { headers });
};


const getDeliveryFeeReport = (sessionID, page, limit,business,search_text,status,date,businessIDs) => {
  var payload = {
    "functionName": "DeliveryFeeReport",
    "postData": {
      "business_id": business,
      "search_text": search_text,
      "date_range": date,
      "status": status,
      "businessIDs": businessIDs,
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "ReportsModule/DeliveryFeeReport", payload, { headers });
};

const getSalesReport = (sessionID, page, limit,business,status,item_id,date,businessIDs) => {
  var payload = {
    "functionName": "SalesReport",
    "postData": {
      "business_id": business,
      "product_id": item_id,
      "status":      status,
      "date_range": date,
      "businessIDs": businessIDs,
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "ReportsModule/SalesReport", payload, { headers });
};

const UpdateStatus = (sessionID,selectedStatus,orderId,deliveryMethod) => {
  var payload = {
    "functionName": "UpdateStatusManually",
    "postData": {
      "order_id": orderId,
      "status": selectedStatus,
      "deliveryMethod": deliveryMethod
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "OrderModule/UpdateStatusManually", payload, { headers });
};

const getUserPointStatement = (sessionID, page, limit,business,search_text,date,businessIDs) => {
  var payload = {
    "functionName": "UserPointStatement",
    "postData": {
      "business_id": business,
      "search_text": search_text,
      "date_range": date,
      "businessIDs": businessIDs,
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "ReportsModule/UserPointStatement", payload, { headers });
};

const getUserStatement = (sessionID, page, limit,business,user,date,businessIDs) => {
  var payload = {
    "functionName": "UserStatement",
    "postData": {
      "user_id": user,
      "type": business,
      "date_range": date,
      "businessIDs": businessIDs,
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "ReportsModule/UserStatement", payload, { headers });
};

const getAllDoctors = (sessionID, page, limit, text, status, type, icVerification) => {
  var payload = {
    "functionName": "GetDoctors",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "text": text,
      "status": status,
      "type": type,
      "IC_Verification": icVerification || "",
      "noActiveMatch": true
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoctorModule/GetDoctors", payload, { headers });
};

const deleteDoctor = (sessionID,id) => {
  var payload = {
    "functionName": "DeleteDoctor",
    "postData": {
      "doctor_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoctorModule/DeleteDoctor", payload, { headers });
};

const restoreDoctor = (sessionID, id) => {
  var payload = {
    functionName: "RestoreDoctor",
    postData: {
      doctor_id: id,
    },
  };
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(B_URL + "DoctorModule/RestoreDoctor", payload, { headers });
};

const deleteBulkDoctors = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkDoctor",
    "postData": {
      "doctor_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoctorModule/DeleteBulkDoctor", payload, { headers });
};

const GetSingleDoctor = (sessionID,id) => {
  var payload = {
    "functionName": "GetSingleDoctorGetSingleDoctor",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoctorModule/GetSingleDoctor", payload, { headers });
};

const EditDoctor = (sessionID,data,id) => {
  console.log("DATA:", data);
  var payload = {
    "functionName": "UpdateDoctor",
    "postData": {
      "doctor_id": id,
      "first_name": data.first_name,
      "last_name": data.last_name,
      "email": data.email,
      "type": data.type,
      "password": data.password,
      "status": data.status,
      "document_action": data.document_action,
      "document_msg": data.document_action === 'Rejected' ? data.rejection_message : '',
      "mmc_expiry_datetime": data.mmc_expiry_datetime,
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoctorModule/UpdateDoctor", payload, { headers });
};


const getAllSymptoms = (sessionID, page, limit,text,status,type,noActiveMatch) => {
  var payload = {
    "functionName": "GetSymptoms",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "text": text,
      "status": status,
      "type": type,
      "noActiveMatch": noActiveMatch
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "SymptomModule/GetSymptoms", payload, { headers });
};

const deleteSymptom = (sessionID,id) => {
  var payload = {
    "functionName": "DeleteSymptom",
    "postData": {
      "symptom_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "SymptomModule/DeleteSymptom", payload, { headers });
};

const deleteBulkSymptom = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkSymptom",
    "postData": {
      "symptom_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "SymptomModule/DeleteBulkSymptom", payload, { headers });
};


const AddSymptom = (sessionID,data) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "AddSymptom",
    "postData": {
      "name": data.name,
      "type": data.type,
      "status": 'Active',
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "SymptomModule/AddSymptom", payload, { headers });
};


const GetSingleSymptom = (sessionID,id) => {
  var payload = {
    "functionName": "GetSingleSymptom",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "SymptomModule/GetSingleSymptom", payload, { headers });
};


const EditSymptom = (sessionID,data,id) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "UpdateSymptom",
    "postData": {
      "symptom_id": id,
      "name": data.name,
      "type": data.type,
      "status": data.status,
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "SymptomModule/UpdateSymptom", payload, { headers });
};

const getAllPatients = (sessionID, page, limit,parent_id,text,status, icVerification) => {
  var payload = {
    "functionName": "GetPatients",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "text": text,
      "status": status,
      "parent_id": parent_id,
      "IC_Verification": icVerification || "",
      "noActiveMatch": true
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PatientModule/GetPatients", payload, { headers });
};

const GetSinglePatient = (sessionID, id) => {
  var payload = {
    "functionName": "GetSinglePatient",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PatientModule/GetSinglePatient", payload, { headers });
};

const EditPatient = (sessionID, data, id) => {
  var payload = {
    "functionName": "UpdatePatient",
    "postData": {
      "patient_id": id,
      "status": data.status,
      "rejection_reason": data.status === 'Rejected' ? data.rejection_message : '',
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PatientModule/UpdatePatient", payload, { headers });
};

const getPatientRejectionReason = (sessionID, patientId) => {
  var payload = {
    "functionName": "GetPatientRejectionReason",
    "postData": {
      "patient_id": patientId
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PatientModule/GetPatientRejectionReason", payload, { headers });
};

const getPatientAccountStatusHistory = (sessionID, patientId) => {
  var payload = {
    "functionName": "GetPatientAccountStatusHistory",
    "postData": {
      "patient_id": patientId
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PatientModule/GetPatientAccountStatusHistory", payload, { headers });
};

const getPatientICVerificationQueue = (sessionID, page, limit, text, icVerification) => {
  const payload = {
    functionName: "GetPatientICVerificationQueue",
    postData: {
      offset: page,
      limit,
      text: text || "",
      IC_Verification: icVerification || "",
      sort: { datetime_added: -1 },
    },
  };
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(B_URL + "PatientModule/GetPatientICVerificationQueue", payload, { headers });
};

const adminUpdatePatientICVerification = (sessionID, data) => {
  const payload = {
    functionName: "AdminUpdatePatientICVerification",
    postData: data,
  };
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(B_URL + "PatientModule/AdminUpdatePatientICVerification", payload, { headers });
};

const adminCorrectPatientICData = (sessionID, data) => {
  const payload = {
    functionName: "AdminCorrectPatientICData",
    postData: data,
  };
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(B_URL + "PatientModule/AdminCorrectPatientICData", payload, { headers });
};

const getPatientICVerificationHistory = (sessionID, patientId) => {
  const payload = {
    functionName: "GetPatientICVerificationHistory",
    postData: {
      patient_id: patientId,
    },
  };
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(B_URL + "PatientModule/GetPatientICVerificationHistory", payload, { headers });
};

const checkPatientICVerification = (sessionID, patientId) => {
  const payload = {
    functionName: "CheckPatientICVerification",
    postData: {
      patient_id: patientId,
    },
  };
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(B_URL + "PatientModule/CheckPatientICVerification", payload, { headers });
};

const getDoctorICVerificationQueue = (sessionID, page, limit, text, icVerification) => {
  const payload = {
    functionName: "GetDoctorICVerificationQueue",
    postData: {
      offset: page,
      limit,
      text: text || "",
      IC_Verification: icVerification || "",
      sort: { datetime_added: -1 },
    },
  };
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(B_URL + "DoctorModule/GetDoctorICVerificationQueue", payload, { headers });
};

const adminUpdateDoctorICVerification = (sessionID, data) => {
  const payload = {
    functionName: "AdminUpdateDoctorICVerification",
    postData: data,
  };
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(B_URL + "DoctorModule/AdminUpdateDoctorICVerification", payload, { headers });
};

const adminCorrectDoctorICData = (sessionID, data) => {
  const payload = {
    functionName: "AdminCorrectDoctorICData",
    postData: data,
  };
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(B_URL + "DoctorModule/AdminCorrectDoctorICData", payload, { headers });
};

const getDoctorICVerificationHistory = (sessionID, doctorId) => {
  const payload = {
    functionName: "GetDoctorICVerificationHistory",
    postData: {
      doctor_id: doctorId,
    },
  };
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(B_URL + "DoctorModule/GetDoctorICVerificationHistory", payload, { headers });
};

const checkDoctorICVerification = (sessionID, doctorId) => {
  const payload = {
    functionName: "CheckDoctorICVerification",
    postData: {
      doctor_id: doctorId,
    },
  };
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(B_URL + "DoctorModule/CheckDoctorICVerification", payload, { headers });
};

const deletePatient = (sessionID,id) => {
  var payload = {
    "functionName": "DeletePatient",
    "postData": {
      "patient_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PatientModule/DeletePatient", payload, { headers });
};

const restorePatient = (sessionID, id) => {
  var payload = {
    functionName: "RestorePatient",
    postData: {
      patient_id: id,
    },
  };
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(B_URL + "PatientModule/RestorePatient", payload, { headers });
};

const deleteBulkPatients = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkPatient",
    "postData": {
      "patient_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PatientModule/DeleteBulkPatient", payload, { headers });
};

const getAllDocuments = (sessionID, page, limit,text,status,specialization,noActiveMatch) => {
  var payload = {
    "functionName": "GetDocuments",
    "postData": {
      "offset": page,
      "sort": {
        "_id": 1
      },
      "limit": limit,
      "text": text,
      "status": status,
      "specialization_id": specialization,
      "noActiveMatch": noActiveMatch
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DocumentModule/GetDocuments", payload, { headers });
};

const deleteDocument = (sessionID,id) => {
  var payload = {
    "functionName": "DeleteDocument",
    "postData": {
      "document_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DocumentModule/DeleteDocument", payload, { headers });
};

const deleteBulkDocument = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkDocument",
    "postData": {
      "document_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DocumentModule/DeleteBulkDocument", payload, { headers });
};

const AddDocument = (sessionID,data) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "AddDocument",
    "postData": {
      "title": data.title,
      "icon": data.icon,
      "type": data.type,
      "status": 'Active',
      "specializations": data.specializations
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DocumentModule/AddDocument", payload, { headers });
};

const GetSingleDocument = (sessionID,id) => {
  var payload = {
    "functionName": "GetSingleDocument",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DocumentModule/GetSingleDocument", payload, { headers });
};

const EditDocument = (sessionID,data,id) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "UpdateDocument",
    "postData": {
      "document_id": id,
      "title": data.title,
      "icon": data.icon,
      "type": data.type,
      "status": data.status,
      "specializations": data.specializations,
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DocumentModule/UpdateDocument", payload, { headers });
};

const GetDoctorDocuments = (sessionID, doctorId,type,document,document1) => {
  var payload = {
    "functionName": "GetDoctorDocuments",
    "postData": {
      "offset": 0,
      "sort": {
        "_id": -1
      },
      "limit": 10,
      "doctor_id": doctorId,
      "file_type" : type,
      "document_action" : document,
      "document_id" : document1
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DocumentModule/GetDoctorDocuments", payload, { headers });
};

const getDocumentsForDoctor = (sessionID, doctorId) => {
  var payload = {
    "functionName": "GetDocuments",
    "postData": {
      "offset": 0,
      "sort": { "_id": 1 },
      "limit": 1000,
      "doctor_id": doctorId,
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DocumentModule/GetDocuments", payload, { headers });
};

const getAllDoctorDocuments = (sessionID, doctorId) => {
  var payload = {
    "functionName": "GetDoctorDocuments",
    "postData": {
      "offset": 0,
      "sort": { "_id": -1 },
      "limit": 1000,
      "doctor_id": doctorId,
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DocumentModule/GetDoctorDocuments", payload, { headers });
};

const AddDoctorDocument = (sessionID, data) => {
  var payload = {
    "functionName": "AddDoctorDocument",
    "postData": data
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DocumentModule/AddDoctorDocument", payload, { headers });
};

const UpdateDoctorDocument = (sessionID, data) => {
  var payload = {
    "functionName": "UpdateDoctorDocument",
    "postData": data
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DocumentModule/UpdateDoctorDocument", payload, { headers });
};

const regeneratePassword = (sessionID,id) => {
  var payload = {
    "functionName": "RegeneratePassword",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PatientModule/RegeneratePassword", payload, { headers });
};

const getAllDevices = (sessionID, page, limit,text,status,noActiveMatch) => {
  var payload = {
    "functionName": "GetDevices",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "text": text,
      "status": status,
      "noActiveMatch": noActiveMatch
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DeviceModule/GetDevices", payload, { headers });
};

const deleteDevice = (sessionID,id) => {
  var payload = {
    "functionName": "DeleteDevice",
    "postData": {
      "device_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DeviceModule/DeleteDevice", payload, { headers });
};

const deleteBulkDevice = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkDevices",
    "postData": {
      "device_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DeviceModule/DeleteBulkDevice", payload, { headers });
};

const AddDevice = (sessionID,data) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "AddDevice",
    "postData": {
      "title": data.title,
      "sub_title": data.sub_title,
      "features": data.features,
      "price": data.price,
      "total_rating": null,
      "patients_using": null,
      "description": data.description,
      "image": data.image,
      "status": "Active"
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DeviceModule/AddDevice", payload, { headers });
};


const GetSingleDevice = (sessionID,id) => {
  var payload = {
    "functionName": "GetSingleDevice",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DeviceModule/GetSingleDevice", payload, { headers });
};

const EditDevice = (sessionID,data,id) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "UpdateDevice",
    "postData": {
      "device_id": id,
      "title": data.title,
      "sub_title": data.sub_title,
      "features": data.features,
      "price": data.price,
      "description": data.description,
      "image": data.image,
      "status": data.status,
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DeviceModule/UpdateDevice", payload, { headers });
};

const getAllSpecializations = (sessionID, page, limit,text,status,type,noActiveMatch) => {
  var payload = {
    "functionName": "GetSpecializations",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "text": text,
      "status": status,
      "type": type,
      "noActiveMatch": noActiveMatch
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "SpecializationCategoryModule/GetSpecializations", payload, { headers });
};

const deleteSpecialization = (sessionID,id) => {
  var payload = {
    "functionName": "DeleteSpecialization",
    "postData": {
      "sp_cat_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "SpecializationCategoryModule/DeleteSpecialization", payload, { headers });
};


const deleteBulkSpecialization = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkSpecialization",
    "postData": {
      "sp_cat_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "SpecializationCategoryModule/DeleteBulkSpecialization", payload, { headers });
};

const AddSpecialization = (sessionID,data) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "AddSpecialization",
    "postData": {
      "name": data.name,
      "type": data.type,
      "status": 'Active',
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "SpecializationCategoryModule/AddSpecialization", payload, { headers });
};

const GetSingleSpecialization = (sessionID,id) => {
  var payload = {
    "functionName": "GetSingleSpecialization",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "SpecializationCategoryModule/GetSingleSpecialization", payload, { headers });
};

const EditSpecialization = (sessionID,data,id) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "UpdateSpecialization",
    "postData": {
      "sp_cat_id": id,
      "name": data.name,
      "type": data.type,
      "status": data.status,
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "SpecializationCategoryModule/UpdateSpecialization", payload, { headers });
};


const getAllNurseCares = (sessionID, page, limit,text,status,noActiveMatch) => {
  var payload = {
    "functionName": "GetNurseCares",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "text": text,
      "status": status,
      "noActiveMatch": noActiveMatch
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "NurseCareModule/GetNurseCares", payload, { headers });
};

const deleteNurseCare = (sessionID,id) => {
  var payload = {
    "functionName": "DeleteNurseCare",
    "postData": {
      "nurse_care_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "NurseCareModule/DeleteNurseCare", payload, { headers });
};

const deleteBulkNurseCare = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkNurseCare",
    "postData": {
      "nurse_care_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "NurseCareModule/DeleteBulkNurseCare", payload, { headers });
};

const AddNurseCare = (sessionID,data) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "AddNurseCare",
    "postData": {
      "name": data.name,
      "status": 'Active',
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "NurseCareModule/AddNurseCare", payload, { headers });
};

const GetSingleNurseCare = (sessionID,id) => {
  var payload = {
    "functionName": "GetSingleNurseCare",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "NurseCareModule/GetSingleNurseCare", payload, { headers });
};

const EditNurseCare = (sessionID,data,id) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "UpdateNurseCare",
    "postData": {
      "nurse_care_id": id,
      "name": data.name,
      "status": data.status,
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "NurseCareModule/UpdateNurseCare", payload, { headers });
};

const GetAppAddresses = (sessionID, page, limit,patient_id,text) => {
  var payload = {
    "functionName": "GetAppAddresses",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "patient_id": patient_id,
      "text": text
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "AppAddressModule/GetAppAddresses", payload, { headers });
};


const getAllRelations = (sessionID, page, limit,text,status,noActiveMatch) => {
  var payload = {
    "functionName": "GetRelations",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "text": text,
      "status": status,
      "noActiveMatch": noActiveMatch
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "RelationModule/GetRelations", payload, { headers });
};


const deleteRelation = (sessionID,id) => {
  var payload = {
    "functionName": "DeleteRelation",
    "postData": {
      "relation_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "RelationModule/DeleteRelation", payload, { headers });
};

const deleteBulkRelation = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkRelation",
    "postData": {
      "relation_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "RelationModule/DeleteBulkRelation", payload, { headers });
};

const AddRelation = (sessionID,data) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "AddRelation",
    "postData": {
      "name": data.name,
      "status": 'Active'
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "RelationModule/AddRelation", payload, { headers });
};

const GetSingleRelation = (sessionID,id) => {
  var payload = {
    "functionName": "GetSingleRelation",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "RelationModule/GetSingleRelation", payload, { headers });
};


const EditRelation = (sessionID,data,id) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "UpdateRelation",
    "postData": {
      "relation_id": id,
      "name": data.name,
      "status": data.status
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "RelationModule/UpdateRelation", payload, { headers });
};


const regeneratePasswordDoctor = (sessionID,id) => {
  var payload = {
    "functionName": "RegeneratePassword",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoctorModule/RegeneratePassword", payload, { headers });
};

const sendDoctorCredentials = (sessionID, id) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoctorModule/send-credentials/" + id, {}, { headers });
};

const resetDoctorCredentials = (sessionID, id) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoctorModule/reset-credentials/" + id, {}, { headers });
};

const sendPatientCredentials = (sessionID, id) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PatientModule/send-credentials/" + id, {}, { headers });
};

const resetPatientCredentials = (sessionID, id) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PatientModule/reset-credentials/" + id, {}, { headers });
};


const getAllTimes = (sessionID, page, limit,text,status,noActiveMatch) => {
  var payload = {
    "functionName": "GetMedicineTimes",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "text": text,
      "status": status,
      "noActiveMatch": noActiveMatch
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "MedicineTimeModule/GetMedicineTimes", payload, { headers });
};

const AddTime = (sessionID,data) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "AddMedicineTime",
    "postData": {
      "name": data.name,
      "status": 'Active'
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "MedicineTimeModule/AddMedicineTime", payload, { headers });
};

const deleteTime = (sessionID,id) => {
  var payload = {
    "functionName": "DeleteMedicineTime",
    "postData": {
      "time_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "MedicineTimeModule/DeleteMedicineTime", payload, { headers });
};

const deleteBulkTime = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkMedicineTime",
    "postData": {
      "time_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "MedicineTimeModule/DeleteBulkMedicineTime", payload, { headers });
};

const GetSingleTime = (sessionID,id) => {
  var payload = {
    "functionName": "GetSingleMedicineTime",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "MedicineTimeModule/GetSingleMedicineTime", payload, { headers });
};


const EditTime = (sessionID,data,id) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "UpdateMedicineTime",
    "postData": {
      "time_id": id,
      "name": data.name,
      "status": data.status
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "MedicineTimeModule/UpdateMedicineTime", payload, { headers });
};

const getAllQuantities = (sessionID, page, limit,text,status,noActiveMatch) => {
  var payload = {
    "functionName": "GetQuantityMeasures",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "text": text,
      "status": status,
      "noActiveMatch": noActiveMatch
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "QuantityMeasureModule/GetQuantityMeasures", payload, { headers });
};

const AddQuantity = (sessionID,data) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "AddQuantityMeasure",
    "postData": {
      "name": data.name,
      "status": "Active"
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "QuantityMeasureModule/AddQuantityMeasure", payload, { headers });
};


const deleteQuantity = (sessionID,id) => {
  var payload = {
    "functionName": "DeleteQuantityMeasure",
    "postData": {
      "quantity_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "QuantityMeasureModule/DeleteQuantityMeasure", payload, { headers });
};

const deleteBulkQuantity = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkQuantityMeasure",
    "postData": {
      "quantity_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "QuantityMeasureModule/DeleteBulkQuantityMeasure", payload, { headers });
};


const GetSingleQuantity = (sessionID,id) => {
  var payload = {
    "functionName": "GetSingleQuantityMeasure",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "QuantityMeasureModule/GetSingleQuantityMeasure", payload, { headers });
};


const EditQuantity = (sessionID,data,id) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "UpdateQuantityMeasure",
    "postData": {
      "quantity_id": id,
      "name": data.name,
      "status": data.status
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "QuantityMeasureModule/UpdateQuantityMeasure", payload, { headers });
};


const getAllCurrencies = (sessionID, page, limit,status,noActiveMatch) => {
  var payload = {
    "functionName": "GetCurrencies",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "status": status,
      "noActiveMatch": noActiveMatch
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "CurrencyModule/GetCurrencies", payload, { headers });
};

const getAllDoctorLadgers = (sessionID, page, limit,status) => {
  var payload = {
  "functionName": "getDoctorLadgers",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "doctor_id": status
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getDoctorLadgers", payload, { headers });
};


const getAllPatientLadgers = (sessionID, page, limit,status) => {
  var payload = {
  "functionName": "getPatientLadgers",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "patient_id": status
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getPatientLadgers", payload, { headers });
};

const getAllPharmacyLadgers = (sessionID, page, limit, searchText) => {
  var payload = {
  "functionName": "getPharmacyLadgers",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "search_text": searchText
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getPharmacyLadgers", payload, { headers });
};

const getPharmacyLadgerDetails = (sessionID, page, limit,status, pharmacyLadgerId) => {
  var payload = {
  "functionName": "getPharmacyLadgerDetails",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "status": status,
    "pharmacy_ladger_id": pharmacyLadgerId
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getPharmacyLadgerDetails", payload, { headers });
};

const getSinglePharmacyLadgerDetails = (sessionID, ledgerDetailId) => {
  var payload = {
    "functionName": "getSinglePharmacyLadgerDetails",
    "postData": {
      "ledger_detail_id": ledgerDetailId
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getSinglePharmacyLadgerDetails", payload, { headers });
};

// Pharmacy Withdrawal Request Service Methods
const getAllPharmacyWithdrawlRequest = (sessionID, page, limit, status) => {
  var payload = {
  "functionName": "PharmacygetWithdrawlRequest",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "status": status
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/PharmacygetWithdrawlRequest", payload, { headers });
};

const addPharmacyWithdrawlRequest = (sessionID, pharmacy_id, requested_amount) => {
  var payload = {
  "functionName": "PharmacyWithdrawlRequest",
  "postData": {
    "pharmacy_id": pharmacy_id,
    "requested_amount": requested_amount
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/PharmacyWithdrawlRequest", payload, { headers });
};

const pharmacyWithdrawlRequestAction = (sessionID, pharmacy_id, withdrawl_id, status, rejection_reason, atteched_file) => {
  var payload = {
  "functionName": "PharmacyWithdrawlRequestAction",
  "postData": {
    "pharmacy_id": pharmacy_id,
    "withdrawl_id": withdrawl_id,
    "status": status,
    "rejection_reason": rejection_reason,
    "atteched_file": atteched_file
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/PharmacyWithdrawlRequestAction", payload, { headers });
};

const getPharmacyWithDrawlRequestDetails = (sessionID, page, limit, status, pharmacyId) => {
  var payload = {
  "functionName": "getPharmacyLadgerDetails",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "status": status,
    "pharmacy_id": pharmacyId
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getPharmacyLadgerDetails", payload, { headers });
};

const getSinglePharmacyBankAccount = (sessionID, merchantId) => {
  var payload = {
    "functionName": "GetSinglePharmacyBankAccount",
    "postData": {
      "merchant_id": merchantId
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/GetSinglePharmacyBankAccount", payload, { headers });
};

const getPharmacyBankAccountWithDetails = (sessionID, merchantId) => {
  var payload = {
    "functionName": "GetPharmacyBankAccountWithDetails",
    "postData": {
      "merchant_id": merchantId
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/GetPharmacyBankAccountWithDetails", payload, { headers });
};

const getAllWithdrawlRequest = (sessionID, page, limit,status) => {
  var payload = {
  "functionName": "getWithdrawlRequest",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "status": status
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getWithdrawlRequest", payload, { headers });
};


const getAllPatientWithdrawlRequest = (sessionID, page, limit,status) => {
  var payload = {
  "functionName": "getPatientWithdrawlRequest",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "status": status
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getPatientWithdrawlRequest", payload, { headers });
};

const getDoctorLadgerDetails = (sessionID, page, limit,status, doctorLadgerId) => {
  var payload = {
  "functionName": "getDoctorLadgerDetails",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "status": status,
    "doctor_ladger_id": doctorLadgerId
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getDoctorLadgerDetails", payload, { headers });
};

const getSingleDoctorLadgerDetails = (sessionID, ledgerDetailId) => {
  var payload = {
    "functionName": "getSingleDoctorLadgerDetails",
    "postData": {
      "ledger_detail_id": ledgerDetailId
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getSingleDoctorLadgerDetails", payload, { headers });
};

const getSinglePatientLadgerDetails = (sessionID, ledgerDetailId) => {
  var payload = {
    "functionName": "getSinglePatientLadgerDetails",
    "postData": {
      "ledger_detail_id": ledgerDetailId
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getSinglePatientLadgerDetails", payload, { headers });
};

const getPatientLadgerDetails = (sessionID, page, limit,status, doctorLadgerId) => {
  var payload = {
  "functionName": "getPatientLadgerDetails",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "status": status,
    "patient_ladger_id": doctorLadgerId
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getPatientLadgerDetails", payload, { headers });
};




const getSARALadgerDetails = (sessionID, page, limit,status) => {
  var payload = {
  "functionName": "getSaraLadgerDetails",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "status": status
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getSaraLadgerDetails", payload, { headers });
};

const getWithDrawlRequestDetails = (sessionID, page, limit,status, doctorId) => {
  var payload = {
  "functionName": "getDoctorLadgerDetails",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "status": status,
    "doctor_id": doctorId
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getDoctorLadgerDetails", payload, { headers });
};


const getPatientWithDrawlRequestDetails = (sessionID, page, limit,status, doctorId) => {
  var payload = {
  "functionName": "getPatientLadgerDetails",
  "postData": {
    "offset": page,
    "sort": {
      "_id": -1
    },
    "limit": limit,
    "status": status,
    "patient_id": doctorId
  }
}
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "LadgersModule/getPatientLadgerDetails", payload, { headers });
};


const deleteCurrency = (sessionID,id) => {
  var payload = {
    "functionName": "DeleteCurrency",
    "postData": {
      "currency_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "CurrencyModule/DeleteCurrency", payload, { headers });
};

const deleteBulkCurrency = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkCurrencies",
    "postData": {
      "currency_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "CurrencyModule/DeleteBulkCurrencies", payload, { headers });
};

const AddCurrency = (sessionID,data) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "AddCurrency",
    "postData": {
      "name": data.name,
      "status": 'Active'
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "CurrencyModule/AddCurrency", payload, { headers });
};

const GetSingleCurrency = (sessionID,id) => {
  var payload = {
    "functionName": "GetSingleCurrency",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "CurrencyModule/GetSingleCurrency", payload, { headers });
};

const EditCurrency = (sessionID,data,id) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "UpdateCurrency",
    "postData": {
      "currency_id": id,
      "name": data.name,
      "status": data.status
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "CurrencyModule/UpdateCurrency", payload, { headers });
};

const getAllDoses = (sessionID, page, limit,text,status,noActiveMatch) => {
  var payload = {
    "functionName": "GetDoses",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "text": text,
      "status": status,
      "noActiveMatch": noActiveMatch
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoseModule/GetDoses", payload, { headers });
};

const AddDose = (sessionID,data) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "AddDose",
    "postData": {
      "name": data.name,
      "quantity_id": data.quantity_id,
      "status": "Active"
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoseModule/AddDose", payload, { headers });
};

const deleteDose = (sessionID,id) => {
  var payload = {
    "functionName": "DeleteDose",
    "postData": {
      "dose_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoseModule/DeleteDose", payload, { headers });
};

const deleteBulkDose = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkDose",
    "postData": {
      "dose_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoseModule/DeleteBulkDose", payload, { headers });
};

const GetSingleDose = (sessionID,id) => {
  var payload = {
    "functionName": "GetSingleDose",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoseModule/GetSingleDose", payload, { headers });
};

const EditDose = (sessionID,data,id) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "UpdateDose",
    "postData": {
      "dose_id": id,
      "name": data.name,
      "quantity_id": data.quantity_id,
      "status": data.status
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "DoseModule/UpdateDose", payload, { headers });
};


const getAllMessages = (sessionID, page, limit,text,status,type,noActiveMatch) => {
  var payload = {
    "functionName": "GetPreSetMessages",
    "postData": {
      "offset": page,
      "sort": {
        "_id": -1
      },
      "limit": limit,
      "text": text,
      "status": status,
      "type": type,
      "noActiveMatch": noActiveMatch
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PreSetMessages/GetPreSetMessages", payload, { headers });
};

const deleteMessage = (sessionID,id) => {
  var payload = {
    "functionName": "DeletePreSetMessages",
    "postData": {
      "pre_set_id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PreSetMessages/DeletePreSetMessages", payload, { headers });
};

const deleteBulkMessage = (sessionID,selectedRows) => {
  var payload = {
    "functionName": "DeleteBulkPreSetMessages",
    "postData": {
      "pre_set_ids": selectedRows
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PreSetMessages/DeleteBulkPreSetMessages", payload, { headers });
};

const AddMessage = (sessionID,data) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "AddPreSetMessages",
    "postData": {
      "name": data.name,
      "type": data.type,
      "status": 'Active',
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PreSetMessages/AddPreSetMessages", payload, { headers });
};

const GetSingleMessage = (sessionID,id) => {
  var payload = {
    "functionName": "GetSinglePreSetMessage",
    "postData": {
      "id": id
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PreSetMessages/GetSinglePreSetMessage", payload, { headers });
};

const EditMessage = (sessionID,data,id) => {
  // console.log("DATA:", data);
  var payload = {
    "functionName": "UpdatePreSetMessages",
    "postData": {
      "pre_set_id": id,
      "name": data.name,
      "type": data.type,
      "status": data.status,
    }
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(B_URL + "PreSetMessages/UpdatePreSetMessages", payload, { headers });
};

const DiscountCouponService = {
    getAllDiscountCoupons,
    getAllBusinesses,
    AddDiscountCoupon,
    deleteDiscountCoupon,
    EditDiscountCoupon,
    GetSingleDiscountCoupon,
    deleteBulkDiscountSection,
    updateBulkStatus,
    getAllOrders,
    GetOrderDetails,
    AdminProcessOrder,
    AdditionalTip,
    LalamoveLinkID,
    CancelLalamoveOrder,
    getSettlementReport,
    getSalesReport,
    getDeliveryFeeReport,
    UpdateStatus,
    getUserPointStatement,
    getUserStatement,
    getAllDoctors,
    getDoctorICVerificationQueue,
    adminUpdateDoctorICVerification,
    adminCorrectDoctorICData,
    getDoctorICVerificationHistory,
    checkDoctorICVerification,
    deleteDoctor,
    restoreDoctor,
    deleteBulkDoctors,
    GetSingleDoctor,
    EditDoctor,
    getAllSymptoms,
    deleteSymptom,
    deleteBulkSymptom,
    AddSymptom,
    GetSingleSymptom,
    EditSymptom,
    getAllPatients,
    GetSinglePatient,
    EditPatient,
    getPatientRejectionReason,
    getPatientAccountStatusHistory,
    getPatientICVerificationQueue,
    adminUpdatePatientICVerification,
    adminCorrectPatientICData,
    getPatientICVerificationHistory,
    checkPatientICVerification,
    deletePatient,
    restorePatient,
    deleteBulkPatients,
    getAllDocuments,
    deleteDocument,
    deleteBulkDocument,
    AddDocument,
    GetSingleDocument,
    EditDocument,
    GetDoctorDocuments,
    getDocumentsForDoctor,
    getAllDoctorDocuments,
    AddDoctorDocument,
    UpdateDoctorDocument,
    regeneratePassword,
    getAllDevices,
    deleteDevice,
    deleteBulkDevice,
    AddDevice,
    GetSingleDevice,
    EditDevice,
    getAllSpecializations,
    deleteSpecialization,
    deleteBulkSpecialization,
    AddSpecialization,
    GetSingleSpecialization,
    EditSpecialization,
    getAllNurseCares,
    deleteNurseCare,
    deleteBulkNurseCare,
    AddNurseCare,
    GetSingleNurseCare,
    EditNurseCare,
    GetAppAddresses,
    getAllRelations,
    deleteRelation,
    deleteBulkRelation,
    AddRelation,
    GetSingleRelation,
    EditRelation,
    regeneratePasswordDoctor,
    sendDoctorCredentials,
    resetDoctorCredentials,
    sendPatientCredentials,
    resetPatientCredentials,
    getAllTimes,
    AddTime,
    deleteTime,
    deleteBulkTime,
    GetSingleTime,
    EditTime,
    getAllQuantities,
    AddQuantity,
    deleteQuantity,
    deleteCurrency,
    deleteBulkQuantity,
    deleteBulkCurrency,
    GetSingleQuantity,
    GetSingleCurrency,
    EditQuantity,
    EditCurrency,
    getAllCurrencies,
    getAllDoctorLadgers,
    getAllWithdrawlRequest,
    getAllPatientWithdrawlRequest,
    AddCurrency,

    getAllDoses,
    AddDose,
    deleteDose,
    deleteBulkDose,
    GetSingleDose,
    EditDose,

    getAllMessages,
    AddMessage,
    deleteMessage,
    deleteBulkMessage,
    GetSingleMessage,
    EditMessage,
    getDoctorLadgerDetails,
    getSingleDoctorLadgerDetails,
    getSinglePatientLadgerDetails,
    getSARALadgerDetails,
    getWithDrawlRequestDetails,
    getPatientWithDrawlRequestDetails,
    getPatientLadgerDetails,
    getAllPatientLadgers,
    getAllPharmacyLadgers,
    getPharmacyLadgerDetails,
    getSinglePharmacyLadgerDetails,
    getAllPharmacyWithdrawlRequest,
    addPharmacyWithdrawlRequest,
    pharmacyWithdrawlRequestAction,
    getPharmacyWithDrawlRequestDetails,
    getSinglePharmacyBankAccount,
    getPharmacyBankAccountWithDetails

};

export default DiscountCouponService;